import { render, staticRenderFns } from "./TransactionDetailModal.vue?vue&type=template&id=c49b4796&scoped=true&"
import script from "./TransactionDetailModal.vue?vue&type=script&lang=js&"
export * from "./TransactionDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./TransactionDetailModal.vue?vue&type=style&index=0&id=c49b4796&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49b4796",
  null
  
)

export default component.exports